<div>
	<h1 style=" color: white;">Organigrama</h1>
	<span style="color: white !important; backdrop-filter: invert(1);">Haz click sobre el puesto para ver las personas que se han contratado</span>
</div>
<div class="chart">
	<div class="chart-container"></div>
</div>
<div class="data-contract" [hidden]="filterPositions.length == 0">
	<div class="container">
		<h3 style="color: gray;">Personal contratado para <em><b style="color: black;">{{seeingPosition?.name}}</b></em></h3>
		<div class="table-responsive">
			<table class="table table-striped">
				<thead>
					<tr>
						<th>Foto</th>
						<th>Nombre</th>
						<th>Apellido</th>
						<th>Genero</th>
						<th>Identificacion</th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let p of filterPositions">
						<tr>
							<td><img src="{{p.foto?p.foto:'../../../../../assets/img/nophoto.svg'}}" alt=""></td>
							<td>{{p.nombre}}</td>
							<td>{{p.apellido}}</td>
							<td>{{p.genero=='H'?'Hombre':'Mujer'}}</td>
							<td>{{p.identificacion}}</td>
						</tr>
					</ng-container>
				</tbody>
			</table>
		</div>
		<div class="close-button">
			<button class="btn btn-primary" (click)="filterPositions=[]"><i class="fa fa-circle-xmark"></i>CERRAR</button>
		</div>
	</div>
</div>